module.exports = __webpack_public_path__ + "static/erweima-business.4c85a326.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/financing/erweima-business.png
// module id = 979
// module chunks = 2